import { Environment } from '../environment.interface';

const stagingConfig: Environment = {
  production: false,
  app: {
    appBuild: 29,
    applicationId: '673195753',
    appName: 'aha-smarttv-ui-staging',
    majorVersion: '0',
    minorVersion: '0',
    patchVersion: '1',
    appVersionId: '673198239',
    asn: '10796',
    asnowner: 'Time Warner Cable Internet LLC',
  },
  youbora: {
    accountCode: 'firstlightdev',
  },
  configUrl:
    'https://config-service-cdn.ahacms-stag.firstlight.ai/launch/config',
  // configUrl:
  //   'https://config-service-cdn.api.ahacms.firstlight.ai/launch/config',
};

export default stagingConfig;
